import { render, staticRenderFns } from "./overdue-invoices-list.vue?vue&type=template&id=4389792e&scoped=true"
import script from "./overdue-invoices-list.vue?vue&type=script&lang=ts"
export * from "./overdue-invoices-list.vue?vue&type=script&lang=ts"
import style0 from "./overdue-invoices-list.vue?vue&type=style&index=0&id=4389792e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4389792e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4389792e')) {
      api.createRecord('4389792e', component.options)
    } else {
      api.reload('4389792e', component.options)
    }
    module.hot.accept("./overdue-invoices-list.vue?vue&type=template&id=4389792e&scoped=true", function () {
      api.rerender('4389792e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ledgers/overdue-invoices-list.vue"
export default component.exports